<template>
    <div class="flex items-center gap-1">
      <button
        v-for="n in maxStars"
        :key="n"
        type="button"
        @click="selectRating(n)"
        class="focus:outline-none"
        v-bind="isDesktop ? {
          onMouseover: () => hoverRating = n,
          onMouseleave: () => hoverRating = 0
        } : {}"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
            :fill="(isMobile ? currentRating : hoverRating || currentRating) >= n ? 'gold' : 'white'"
            :stroke="'#FFD700'"
            stroke-width="1.5"
          viewBox="0 0 24 24"
          class="w-6 h-6 transition-colors"
        >
          <path
            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
          />
        </svg>
      </button>
    </div>
  </template>
  
  <script setup>
  import { ref, watch } from 'vue'
  
  const props = defineProps({
    modelValue: {
      type: Number,
      default: 0,
    },
    maxStars: {
      type: Number,
      default: 5,
    },
  })
  const { isMobile, isDesktop } = useDevice();
  const emit = defineEmits(['update:modelValue'])
  
  const currentRating = ref(props.modelValue)
  const hoverRating = ref(0)
  
  watch(
    () => props.modelValue,
    (val) => (currentRating.value = val)
  )
  
function selectRating(n) {
  if (currentRating.value === n) {
    currentRating.value = 0
    emit('update:modelValue', 0)
  } else {
    currentRating.value = n
    emit('update:modelValue', n)
  }
}
  </script>